import styles from "./styles.module.scss";
import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { useProductTable } from "./useProductTable";
import { RoutedModal } from "../../../common";
import { DeleteProduct } from "../DeleteProduct";

export const ProductTable = ({
  products: productList,
  metaDetails,
  gotoPage,
  ...rest
}) => {
  const {
    instance,
    views,
    isFetchingProductDetails,
    selectedProduct,
    setViews,
  } = useProductTable({
    productList,
    ...rest,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        classNames={styles.allProductsTable}
        hasAction={true}
      >
        <div className="text-center mt-5 mb-5">
          <img src={Images.productsEmptyState} width="250px" alt="" />
          <h4 className="font-weight-semibold text-center mt-4">
            You have no products
          </h4>
          <p className="text-center">
            Use the button above to add your products. When you do, they would
            appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {productList?.length > 0 && (
        <secondaryComponents.Pagination
          totalPageNumber={metaDetails?.last_page}
          handlePageClick={(value) => gotoPage(value?.selected + 1)}
          currentPage={metaDetails?.current_page}
          perPage={metaDetails?.per_page}
          unit="products"
        />
      )}

      {/* Delete pormpt */}
      <RoutedModal
        isActive={!!views.isDelete}
        width={500}
        headerTitle="Delete Service"
        closeModal={() => setViews((prev) => ({ ...prev, isDelete: null }))}
        style={{ height: "auto" }}
      >
        <DeleteProduct
          selectedItem={views.isDelete}
          closeModal={() => setViews((prev) => ({ ...prev, isDelete: null }))}
        />
      </RoutedModal>

      {/* add stock modal */}
      <secondaryComponents.SideModal
        width={1400}
        isActive={!!views?.isRestock}
        closeModal={() => setViews((prev) => ({ ...prev, isRestock: null }))}
      >
        <secondaryComponents.LoaderHelper
          classNames="mt-5"
          isLoading={isFetchingProductDetails}
        >
          <secondaryComponents.AddProductStock
            closeWidget={() =>
              setViews((prev) => ({ ...prev, isRestock: null }))
            }
            selectedProduct={selectedProduct}
          />
        </secondaryComponents.LoaderHelper>
      </secondaryComponents.SideModal>

      {/* barcode */}
      <secondaryComponents.SideModal
        isActive={!!views?.isBarcode}
        closeModal={() => setViews((prev) => ({ ...prev, isBarcode: null }))}
      >
        <secondaryComponents.LoaderHelper
          classNames="mt-5"
          isLoading={isFetchingProductDetails}
        >
          <secondaryComponents.ProductBarcode
            closeWidget={() =>
              setViews((prev) => ({ ...prev, isBarcode: null }))
            }
            selectedProduct={selectedProduct}
          />
        </secondaryComponents.LoaderHelper>
      </secondaryComponents.SideModal>
    </>
  );
};
